<template>
	<div class="frontend_html" :style="{'height': layout.height + 'px'}">
		<div class="data-area">
			<div id="left_editor">在此处输入将要格式化的代码...</div>
			<div id="right_editor"></div>
		</div>
		<div class="opera-area">
			<Select size="small" v-model="language" style="width:100px">
				<Option v-for="item in language_list" :value="item" :key="item">{{ item }}</Option>
			</Select>
			<Select size="small" v-model="attributes.indent_size" style="width:170px">
				<Option v-for="item in indent_list" :value="item" :key="item">Indent with {{ item }} spaces</Option>
			</Select>
			<Checkbox v-model="attributes.keep_array_indent" style="margin-top:4px;">Keep Array Indentation</Checkbox>
			<Button type="primary" @click="format()" size="small">格式化</Button>
		</div>
	</div>
</template>

<script>
	import * as ace from 'brace';
	import 'brace/mode/javascript';
	import 'brace/mode/html';
	import 'brace/mode/css';
	import 'brace/theme/xcode';
	import beautify from 'js-beautify';

	export default {
		name: "html_format",
		data(){
			return {
				indent_list: [2, 4, 8],
				language_list: ['Auto', 'HTML', 'Javascript', 'CSS'],
				attributes: {
					indent_size: 4,
					keep_array_indent: true,
				},
				left_editor: undefined,
				right_editor: undefined,
				language: 'Auto',
				layout: {
					height: 0,
				}
			}
		},
		computed: {
			src_data: {
				get(){
					return this.left_editor.getValue();
				},
				set(newValue){
					this.left_editor.setValue(newValue);
				}
			},
			dest_data: {
				get(){
					return this.right_editor.getValue();
				},
				set(newValue){
					this.right_editor.setValue(newValue);
				}

			}
		},
		mounted(){
			let that = this;
			this.$nextTick(()=>{
				$('textarea').css({'height': ' 100%', 'resize': 'none'});
				that.left_editor = window.ace.edit('left_editor');
				that.left_editor.$blockScrolling = Infinity;
				that.left_editor.setOption("mode", 'ace/mode/html');
				that.left_editor.setOption("theme", 'ace/theme/xcode');
				that.left_editor.setOption("showLineNumbers", 0);
				that.left_editor.setOption("showGutter", 0);
				that.left_editor.setOption("showPrintMargin", 0);
				that.left_editor.on('focus', ()=>{
					if(that.left_editor.getValue() === '在此处输入将要格式化的代码...'){
						that.left_editor.setValue('');
					}
				});
				that.left_editor.on('blur', ()=>{
					if(that.left_editor.getValue() === ''){
						that.left_editor.setValue('在此处输入将要格式化的代码...');
					}
				});


				that.right_editor = window.ace.edit('right_editor');
				that.right_editor.$blockScrolling = Infinity;
				that.right_editor.setOption("mode", 'ace/mode/html');
				that.right_editor.setOption("theme", 'ace/theme/xcode');
				that.right_editor.setOption("showLineNumbers", 0);
				that.right_editor.setOption("showGutter", 0);
				that.right_editor.setOption("showPrintMargin", 0);

				that.resizeWindow();
				$(window).resize(function(){
					that.resizeWindow();
				});
			})
		},
		methods: {
			format(){
				console.log(this.attributes);
				if(this.language === 'HTML' || (this.language === 'Auto' && this.looks_like_html(this.src_data))){
					this.dest_data = beautify.html(this.src_data, this.attributes);
				}else if(this.language === 'CSS'){
					this.dest_data = beautify.css(this.src_data, this.attributes);
				}else{
					this.dest_data = beautify.js(this.src_data, this.attributes);
				}
			},
			looks_like_html(source){
				let trimmed = source.replace(/^[ \t\n\r]+/, '');
				return trimmed && (trimmed.substring(0, 1) === '<');
			},
			resizeWindow(){
				this.layout.height = window.innerHeight - window.layout.header_height - window.layout.footer_height;
			}
		}
	}
</script>

<style scoped lang="less">
	@import "../../../src/theme/default.less";
	
	.frontend_html {
		display: flex;
		flex-direction: column;
		padding: 20px 20px 20px 20px;
		
		.data-area {
			display: flex;
			flex-direction: row;
			height: 100%;
			
			#left_editor {
				display: flex;
				flex: 1;
				margin-right: 10px;
				border: 1px solid @border-color;
			}
			
			#right_editor {
				display: flex;
				flex: 1;
				margin-right: 10px;
				border: 1px solid @border-color;
			}
		}
		
		.opera-area {
			padding-top: 20px;
			display: flex;
			flex-direction: row;
			height: 50px;
			
			* {
				margin: 0 10px;
			}
		}
	}
	
	textarea {
		resize: none;
	}
</style>
